<div class="zx-max-100-vh h-100 w-100 d-flex flex-column flex-grow-1" [dir]="isRTL ? 'rtl' : 'ltr'">

  <div class="position-absolute w-100 d-flex zx-z-index-1" [class.justify-content-end]="isRTL">
    <button type="button" mat-icon-button aria-label="Close" (click)="closeDialog()"
      class="close-icon d-flex align-items-center justify-content-center zx-z-index-2"
      [class.text-white]="isDarkMode">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="d-flex flex-grow-1 flex-column align-items-center px-3 pt-4 pb-3 px-md-4 pt-md-5 gap-3 w-100 position-relative overflow-hidden">

    <!-- התחלת ייצור – מצב פשוט: כותרת, הערה אופציונלית, כפתורים (מבנה כמו סיום ייצור) -->
    <ng-container *ngIf="isMarkProductionStartedMode">
      <h4 class="text-center fw-bold m-0 pt-3 pt-lg-0" [class.text-white]="isDarkMode">
        {{ "chat.mark-production-started-dialog-title" | translate }}
      </h4>
      <div *ngIf="isSendingQuote" class="d-flex flex-column align-items-center justify-content-center flex-grow-1 py-5">
        <mat-spinner class="zx-medium-icon-size"></mat-spinner>
      </div>
      <div *ngIf="!isSendingQuote" class="d-flex flex-column w-100 gap-3 flex-grow-1">
        <mat-form-field appearance="outline" class="flex-grow-1 w-100 create-price-quote-production-note-field" [class.zx-dark-form]="isDarkMode">
          <mat-label>{{ "chat.mark-production-started-note-label" | translate }}</mat-label>
          <textarea matInput rows="3" [(ngModel)]="productionStartedNote" [placeholder]="'printing-table.additional-notes-placeholder' | translate"
            [class.zx-text-white-bg-transparent]="isDarkMode" [dir]="isRTL ? 'rtl' : 'ltr'"></textarea>
        </mat-form-field>
        <div class="d-flex flex-column flex-sm-row justify-content-center gap-2 w-100 pt-2">
          <button type="button" (click)="onSendProductionStartedMessage()" mat-raised-button
            class="rounded-pill flex-grow-1 fw-bold text-white"
            style="background-color: var(--zx-green);">
            {{ "chat.send-production-started-message" | translate }}
          </button>
          <button (click)="closeDialog()" color="warn" mat-button class="rounded-pill flex-grow-1 fw-bold">
            {{ "su-management.branches_cancel" | translate }}
          </button>
        </div>
      </div>
    </ng-container>

    <!-- סימון שהיצור הסתיים – מצב פשוט: כותרת, הערה אופציונלית, כפתורים -->
    <ng-container *ngIf="isMarkProductionFinishedMode">
      <h4 class="text-center fw-bold m-0 pt-3 pt-lg-0" [class.text-white]="isDarkMode">
        {{ "chat.mark-production-finished-dialog-title" | translate }}
      </h4>
      <div *ngIf="isSendingQuote" class="d-flex flex-column align-items-center justify-content-center flex-grow-1 py-5">
        <mat-spinner class="zx-medium-icon-size"></mat-spinner>
      </div>
      <div *ngIf="!isSendingQuote" class="d-flex flex-column w-100 gap-3 flex-grow-1">
        <mat-form-field appearance="outline" class="flex-grow-1 w-100 create-price-quote-production-note-field" [class.zx-dark-form]="isDarkMode">
          <mat-label>{{ "chat.mark-production-finished-note-label" | translate }}</mat-label>
          <textarea matInput rows="3" [(ngModel)]="productionFinishedNote" [placeholder]="'printing-table.additional-notes-placeholder' | translate"
            [class.zx-text-white-bg-transparent]="isDarkMode" [dir]="isRTL ? 'rtl' : 'ltr'"></textarea>
        </mat-form-field>
        <div class="d-flex flex-column flex-sm-row justify-content-center gap-2 w-100 pt-2">
          <button type="button" (click)="onSendProductionFinishedMessage()" mat-raised-button
            class="rounded-pill flex-grow-1 fw-bold text-white"
            style="background-color: var(--zx-green);">
            {{ "chat.send-production-message" | translate }}
          </button>
          <button (click)="closeDialog()" color="warn" mat-button class="rounded-pill flex-grow-1 fw-bold">
            {{ "su-management.branches_cancel" | translate }}
          </button>
        </div>
      </div>
    </ng-container>

    <!-- סימון כהגעה לכתובת – אותו מבנה כמו סיום ייצור -->
    <ng-container *ngIf="isMarkArrivedAtAddressMode">
      <h4 class="text-center fw-bold m-0 pt-3 pt-lg-0" [class.text-white]="isDarkMode">
        {{ "chat.mark-arrived-at-address-dialog-title" | translate }}
      </h4>
      <div *ngIf="isSendingQuote" class="d-flex flex-column align-items-center justify-content-center flex-grow-1 py-5">
        <mat-spinner class="zx-medium-icon-size"></mat-spinner>
      </div>
      <div *ngIf="!isSendingQuote" class="d-flex flex-column w-100 gap-3 flex-grow-1">
        <mat-form-field appearance="outline" class="flex-grow-1 w-100 create-price-quote-production-note-field" [class.zx-dark-form]="isDarkMode">
          <mat-label>{{ "chat.mark-production-finished-note-label" | translate }}</mat-label>
          <textarea matInput rows="3" [(ngModel)]="arrivedAtAddressNote" [placeholder]="'printing-table.additional-notes-placeholder' | translate"
            [class.zx-text-white-bg-transparent]="isDarkMode" [dir]="isRTL ? 'rtl' : 'ltr'"></textarea>
        </mat-form-field>
        <div class="d-flex flex-column flex-sm-row justify-content-center gap-2 w-100 pt-2">
          <button type="button" (click)="onSendArrivedAtAddressMessage()" mat-raised-button
            class="rounded-pill flex-grow-1 fw-bold text-white"
            style="background-color: var(--zx-green);">
            {{ "chat.send-arrived-at-address-message" | translate }}
          </button>
          <button (click)="closeDialog()" color="warn" mat-button class="rounded-pill flex-grow-1 fw-bold">
            {{ "su-management.branches_cancel" | translate }}
          </button>
        </div>
      </div>
    </ng-container>

    <!-- מצב הצעת מחיר רגיל -->
    <ng-container *ngIf="!isSimpleMessageMode">
    <h4 class="text-center fw-bold m-0 pt-3 pt-lg-0" [class.text-white]="isDarkMode">
      {{ "ph-order-action.create-price-quote" | translate }}
    </h4>

    <!-- מצב הצלחה – מוצג לאחר שליחה מוצלחת -->
    <div *ngIf="isPriceQuoteSentSuccess" class="d-flex flex-column align-items-center justify-content-center flex-grow-1 gap-3 py-5">
      <mat-icon class="text-green" style="font-size: 80px; width: 80px; height: 80px;">check_circle</mat-icon>
      <p class="text-center fw-bold m-0 fs-5" [class.zx-text-white]="isDarkMode">
        {{ "ph-order-action.price-quote-sent-success" | translate }}
      </p>
    </div>

    <!-- טוען -->
    <div *ngIf="isSendingQuote" class="d-flex flex-column align-items-center justify-content-center flex-grow-1 py-5">
      <mat-spinner class="zx-medium-icon-size"></mat-spinner>
    </div>

    <!-- קבצים – אזור גלילה (מבנה כמו בסיכום הזמנה) -->
    <div *ngIf="!isPriceQuoteSentSuccess && !isSendingQuote && getFiles().length" class="d-flex flex-grow-1 w-100 position-relative min-h-0">
      <div class="position-absolute top-0 start-0 end-0 bottom-0 d-flex flex-column align-items-center flex-grow-1 w-100 gap-1 gap-lg-2 overflow-auto p-1 p-lg-2 zx-bg-gray-v-light-opacity rounded-2"
        [class.zx-border-gray-25-pr]="isDarkMode">
        <span class="d-block flex-shrink-0" style="height: 5px;"></span>
        <!-- plotter -->
        <div *ngIf="isPlotterOrder()" class="d-flex flex-column gap-2 w-100">
          <section *ngFor="let file of getFiles(); index as i" class="d-flex flex-column gap-2 p-2 mb-2 rounded-2 zx-bg-gray"
            [class.zx-bg-gray-v-light-opacity]="isDarkMode">
            <article *ngFor="let image of file.images; index as j" class="d-flex align-items-center gap-2"
              [class.flex-row-reverse]="!isRTL">
              <div class="position-relative d-flex align-items-center">
                <img *ngIf="!hasImageError(i,j)" (error)="setImageError(i,j)" class="chat-order-thumb rounded-1"
                  [src]="getImgPlotter(i, j)" alt="" />
                <div *ngIf="hasImageError(i,j)"
                  class="chat-order-thumb rounded-1 d-flex align-items-center justify-content-center bg-light">
                  <mat-icon class="text-red">image_not_supported</mat-icon>
                </div>
                <span *ngIf="file.images?.length > 1" class="position-absolute top-0 p-1 rounded zx-bg-light zx-text-tiny">
                  {{ j + 1 }}/{{ file.images.length }}</span>
              </div>
              <div class="d-flex flex-column gap-1 flex-grow-1">
                <span class="zx-text-small zx-text-pink fw-bold">{{ getDisplayFileNameAfterSplit(file) | slice : 0 : 40 }}{{
                  (getDisplayFileNameAfterSplit(file)).length > 40 ? '...' : '' }}</span>
                <div class="d-flex flex-wrap gap-1 gap-lg-2">
                  <div *ngIf="getPaperSerialName(image?.printSettings?.paperType, order.printerID?.inputBins || [])"
                    class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-gray chat-order-pill"
                    [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                    <span class="zx-text-tiny fw-normal">{{
                      "paper-type.name-short." + getPaperSerialName(image?.printSettings?.paperType,
                      order.printerID?.inputBins || []) | translate }}</span>
                  </div>
                  <div class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-gray chat-order-pill"
                    [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                    <span class="zx-text-tiny fw-normal">{{ (image?.printSettings?.bw ? "printing-table.color-bandw" :
                      "printing-table.color-color") | translate }}</span>
                  </div>
                  <div *ngIf="(image?.printSettings?.numOfCopies || 1) > 1"
                    class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-gray chat-order-pill"
                    [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                    <span class="zx-text-tiny fw-normal">{{ image?.printSettings?.numOfCopies }} {{
                      "printing-table.copies-short" | translate }}</span>
                  </div>
                </div>
                <!-- הורדה [plotter] -->
                <div class="d-flex justify-content-end mt-1">
                  <div [matMenuTriggerFor]="plotterDownloadMenu" class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-green-border-gray c-pointer" [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                    <span class="zx-text-tiny-tiny zx-text-sm-tiny text-green" [class.zx-text-white]="isDarkMode">{{ "su-management.users.download" | translate }}</span>
                  </div>
                  <mat-menu #plotterDownloadMenu="matMenu">
                    <button class="d-flex align-items-center gap-1 px-2" mat-menu-item [class.zx-ltr]="!isRTL" (click)="onDownloadOriginalFile('plotter', j, file, true)">
                      <b class="zx-text-small m-0">{{'su-management.users.download-original' | translate }}</b>
                      <mat-icon class="mx-1 p-0 zx-pt-small">crop_original</mat-icon>
                    </button>
                    <button class="d-flex align-items-center gap-1 px-2" mat-menu-item [class.zx-ltr]="!isRTL" [disabled]="order.status === 'PENDING'" (click)="onDownloadOriginalFile('plotter', j, file, false)">
                      <b class="zx-text-small m-0">{{'su-management.users.download-printed' | translate }}</b>
                      <mat-icon class="mx-1 p-0 zx-pt-small">file_copy</mat-icon>
                    </button>
                  </mat-menu>
                </div>
              </div>
            </article>
            <!-- מחיר לקובץ + הערה -->
            <div class="d-flex flex-column gap-1 mt-1 pt-2 zx-border-top-gray-25-pr">
              <div class="d-flex align-items-center gap-2 flex-wrap" [class.flex-row-reverse]="!isRTL">
                <input type="number" min="0" step="0.01" class="form-control" style="max-width: 120px;"
                  [value]="getFilePrice(i) ?? ''" (input)="onPriceInput(i, $any($event.target).value)"
                  [placeholder]="'0'" [class.zx-text-white]="isDarkMode" />
                <span class="zx-text-small" [class.zx-text-white]="isDarkMode">{{ "printing-table.nis" | translate }}</span>
                <div class="flex-grow-1 d-flex align-items-center gap-2 min-w-0" [class.flex-row-reverse]="!isRTL">
                  <span class="zx-text-tiny flex-shrink-0" [class.zx-text-white]="isDarkMode">{{ "printing-table.additional-notes" | translate }}:</span>
                  <textarea class="create-price-quote-note-input flex-grow-1" rows="2" [name]="'fileNote' + i" [placeholder]="'printing-table.additional-notes-placeholder' | translate"
                    [(ngModel)]="fileNotes[i]" [class.zx-text-white-bg-transparent]="isDarkMode" [dir]="isRTL ? 'rtl' : 'ltr'"></textarea>
                </div>
              </div>
            </div>
          </section>
        </div>

        <!-- express / PH -->
        <div *ngIf="isExpressOrPH()" class="d-flex flex-column gap-2 w-100">
          <section *ngFor="let file of getFiles(); index as i" class="d-flex flex-column gap-2 p-2 mb-2 rounded-2 zx-bg-gray"
            [class.zx-bg-gray-v-light-opacity]="isDarkMode">
            <article class="d-flex align-items-center gap-2" [class.flex-row-reverse]="!isRTL">
              <div class="position-relative d-flex align-items-center">
                <img *ngIf="!hasImageError(i,0)" (error)="setImageError(i,0)" class="chat-order-thumb rounded-1"
                  [src]="getImgExpress(file)" alt="" />
                <div *ngIf="hasImageError(i,0)"
                  class="chat-order-thumb rounded-1 d-flex align-items-center justify-content-center bg-light">
                  <mat-icon class="text-red">image_not_supported</mat-icon>
                </div>
                <span *ngIf="file.images?.length > 1" class="position-absolute top-0 p-1 rounded zx-bg-light zx-text-tiny">1/{{
                  file.images.length }}</span>
              </div>
              <div class="d-flex flex-column gap-1 flex-grow-1">
                <span class="zx-text-small zx-text-pink fw-bold">{{ getDisplayFileNameAfterSplit(file) | slice : 0 : 40 }}{{
                  (getDisplayFileNameAfterSplit(file)).length > 40 ? '...' : '' }}</span>
                <!-- 3D -->
                <div *ngIf="is3DOrder()" class="d-flex flex-wrap gap-1 gap-lg-2">
                  <div *ngIf="file.printSettings?.material"
                    class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-gray chat-order-pill"
                    [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                    <span class="zx-text-tiny fw-normal">{{ ('product-material.name.' + order.productID?.name + '-' +
                      file.printSettings.material) | translate }}</span>
                  </div>
                  <div *ngIf="file.printSettings?.color"
                    class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-gray chat-order-pill"
                    [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                    <span class="zx-text-tiny fw-normal">{{ ('product-color.' + file.printSettings.color) | translate }}</span>
                  </div>
                  <div *ngIf="file.printSettings?.fill != null"
                    class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-gray chat-order-pill"
                    [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                    <span class="zx-text-tiny fw-normal">{{ (file.printSettings.fill * 100 | number:'1.0-0') }}%</span>
                  </div>
                  <div class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-gray chat-order-pill"
                    [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                    <span class="zx-text-tiny fw-normal">{{ (file.printSettings?.numOfCopies || 1) === 1 ?
                      ("printing-table.copy-one" | translate) : (file.printSettings?.numOfCopies || 1) + " " +
                      ("printing-table.copies" | translate) }}</span>
                  </div>
                  <ng-container *ngFor="let pp of (order.productID?.properties?.postProduction || [])">
                    <div *ngIf="pp.available && (file.printSettings?.postProduction || [])?.includes(pp.name)"
                      class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-gray chat-order-pill"
                      [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                      <span class="zx-text-tiny fw-normal">{{ ('product-post-production.' + pp.name) | translate }}</span>
                    </div>
                  </ng-container>
                </div>
                <!-- 2D express -->
                <div *ngIf="!is3DOrder()" class="d-flex flex-wrap gap-1 gap-lg-2">
                  <div
                    *ngIf="getPaperSerialNameExpress(file.printSettings?.paperType, order.printerID?.consumables?.papers || [])"
                    class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-gray chat-order-pill"
                    [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                    <span class="zx-text-tiny fw-normal">{{
                      "paper-type.name-short." +
                      getPaperSerialNameExpress(file.printSettings?.paperType, order.printerID?.consumables?.papers || [])
                      | translate }}</span>
                  </div>
                  <div class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-gray chat-order-pill"
                    [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                    <span class="zx-text-tiny fw-normal">{{ (file.printSettings?.bw ? "printing-table.color-bandw" :
                      "printing-table.color-color") | translate }}</span>
                  </div>
                  <div *ngIf="(file.printSettings?.numOfCopies || 1) > 1"
                    class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-gray chat-order-pill"
                    [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                    <span class="zx-text-tiny fw-normal">{{ file.printSettings.numOfCopies }} {{
                      "printing-table.copies-short" | translate }}</span>
                  </div>
                </div>
                <!-- הורדה [express / PH] -->
                <div class="d-flex justify-content-end mt-1">
                  <div *ngIf="is3DOrder()" (click)="onDownload3DFile(file)" class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-green-border-gray c-pointer" [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                    <span class="zx-text-tiny-tiny zx-text-sm-tiny text-green" [class.zx-text-white]="isDarkMode">{{ "su-management.users.download" | translate }}</span>
                  </div>
                  <ng-container *ngIf="!is3DOrder()">
                    <div [matMenuTriggerFor]="expressDownloadMenu" class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-green-border-gray c-pointer" [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                      <span class="zx-text-tiny-tiny zx-text-sm-tiny text-green" [class.zx-text-white]="isDarkMode">{{ "su-management.users.download" | translate }}</span>
                    </div>
                    <mat-menu #expressDownloadMenu="matMenu">
                      <button class="d-flex align-items-center gap-1 px-2" mat-menu-item [class.zx-ltr]="!isRTL" (click)="onDownloadOriginalFile('express', 0, file, true)">
                        <b class="zx-text-small m-0">{{'su-management.users.download-original' | translate }}</b>
                        <mat-icon class="mx-1 p-0 zx-pt-small">crop_original</mat-icon>
                      </button>
                      <button *ngIf="getOrderFilesSystem(order) === 'express'" class="d-flex align-items-center gap-1 px-2" mat-menu-item [class.zx-ltr]="!isRTL" (click)="onDownloadOriginalFile('express', 0, file, 'processedNotSent')">
                        <b class="zx-text-small m-0">{{'su-management.users.download-processed-not-sent' | translate }}</b>
                        <mat-icon class="mx-1 p-0 zx-pt-small">edit_note</mat-icon>
                      </button>
                      <button class="d-flex align-items-center gap-1 px-2" mat-menu-item [class.zx-ltr]="!isRTL" [disabled]="order.status === 'PENDING'" (click)="onDownloadOriginalFile('express', 0, file, false)">
                        <b class="zx-text-small m-0">{{'su-management.users.download-printed' | translate }}</b>
                        <mat-icon class="mx-1 p-0 zx-pt-small">file_copy</mat-icon>
                      </button>
                    </mat-menu>
                  </ng-container>
                </div>
              </div>
            </article>
            <!-- מחיר לקובץ + הערה -->
            <div class="d-flex flex-column gap-1 mt-1 pt-2 zx-border-top-gray-25-pr">
              <div class="d-flex align-items-center gap-2 flex-wrap" [class.flex-row-reverse]="!isRTL">
                <input type="number" min="0" step="0.01" class="form-control" style="max-width: 120px;"
                  [value]="getFilePrice(i) ?? ''" (input)="onPriceInput(i, $any($event.target).value)"
                  [placeholder]="'0'" [class.zx-text-white]="isDarkMode" />
                <span class="zx-text-small" [class.zx-text-white]="isDarkMode">{{ "printing-table.nis" | translate }}</span>
                <div class="flex-grow-1 d-flex align-items-center gap-2 min-w-0" [class.flex-row-reverse]="!isRTL">
                  <span class="zx-text-tiny flex-shrink-0" [class.zx-text-white]="isDarkMode">{{ "printing-table.additional-notes" | translate }}:</span>
                  <textarea class="create-price-quote-note-input flex-grow-1" rows="2" [name]="'fileNoteExpress' + i" [placeholder]="'printing-table.additional-notes-placeholder' | translate"
                    [(ngModel)]="fileNotes[i]" [class.zx-text-white-bg-transparent]="isDarkMode" [dir]="isRTL ? 'rtl' : 'ltr'"></textarea>
                </div>
              </div>
            </div>
          </section>
        </div>

        <!-- תאריך ושעת אספקה מחייבת – אחרון ברשימה, רק להזמנות PH -->
        <section *ngIf="isPHOrder()" class="d-flex flex-column gap-2 p-2 mb-2 rounded-2 zx-bg-gray w-100"
          [class.zx-bg-gray-v-light-opacity]="isDarkMode">
          <span class="zx-text-small fw-bold" [class.zx-text-white]="isDarkMode">
            {{ "ph-order-action.obligated-delivery" | translate }}
          </span>
          <div class="d-flex flex-column gap-2">
            <!-- תאריך -->
            <div class="d-flex flex-column gap-2">
              <span *ngIf="showStrikethroughDate" class="zx-text-small strikethrough opacity-75 mb-1" [class.zx-text-white]="isDarkMode">
                {{ sourceObligatedDay }} {{ sourceObligatedDate }}
              </span>
              <mat-form-field appearance="outline" class="flex-grow-1 create-price-quote-date-field" [class.zx-dark-form]="isDarkMode">
                <mat-label>{{ "ph-order-action.obligated-date" | translate }}</mat-label>
                <input matInput [matDatepicker]="obligatedDatePicker" [ngModel]="obligatedDateValue"
                  (dateChange)="onObligatedDateChange($event.value)" [min]="minObligatedDate">
                <mat-datepicker-toggle matIconSuffix [for]="obligatedDatePicker"></mat-datepicker-toggle>
                <mat-datepicker #obligatedDatePicker></mat-datepicker>
              </mat-form-field>
            </div>
            <!-- שעה -->
            <div class="d-flex flex-column gap-2">
              <span *ngIf="showStrikethroughTime" class="zx-text-small strikethrough opacity-75 mb-1" [class.zx-text-white]="isDarkMode">
                {{ sourceObligatedTime }}
              </span>
              <mat-form-field appearance="outline" class="flex-grow-1 create-price-quote-time-field" [class.zx-dark-form]="isDarkMode">
                <mat-label>{{ "ph-order-action.obligated-time" | translate }}</mat-label>
                <input matInput type="time" [ngModel]="obligatedTimeValue" (ngModelChange)="onObligatedTimeChange($event)"
                  [class.zx-text-white]="isDarkMode" />
              </mat-form-field>
            </div>
          </div>
        </section>

        <!-- עלות ייצור + עלות שילוח (אם רלוונטי) + הערה – אחרי מועד איסוף -->
        <section class="d-flex flex-column gap-1 p-2 mb-2 rounded-2 zx-bg-gray w-100"
          [class.zx-bg-gray-v-light-opacity]="isDarkMode">
          <div *ngIf="totalBreakdown" class="zx-text-tiny mb-1 d-flex align-items-center gap-1 flex-wrap" [class.flex-row-reverse]="!isRTL" [class.zx-text-white]="isDarkMode">
            <span class="opacity-75">{{ totalBreakdown.printing }} {{ "printing-table.nis" | translate }} ({{ "collect.total.breakdown.printing" | translate }}) + </span>
            <span class="opacity-75">{{ totalBreakdown.shipping }} {{ "printing-table.nis" | translate }} ({{ "collect.total.breakdown.shipping" | translate }}) = </span>
            <span class="fw-bold text-green">{{ getDisplayTotal() }} {{ "printing-table.nis" | translate }}</span>
          </div>
          <div class="row g-2">
            <div [ngClass]="hasShippingOption() ? 'col-6' : 'col-12'">
              <div class="d-flex flex-column gap-1">
                <span class="zx-text-small" [class.zx-text-white]="isDarkMode">{{ "create-price-quote.production-cost" | translate }}</span>
                <div class="d-flex align-items-center gap-2 flex-wrap" [class.flex-row-reverse]="!isRTL">
                  <input type="number" min="0" step="0.01" name="totalInput" class="form-control" style="max-width: 120px;"
                    [(ngModel)]="totalInputValue" (ngModelChange)="onTotalInputChange()" (blur)="onTotalBlur()"
                    [placeholder]="'0'" [class.zx-text-white]="isDarkMode" />
                  <span class="zx-text-small" [class.zx-text-white]="isDarkMode">{{ "printing-table.nis" | translate }}</span>
                  <span *ngIf="showStrikethroughTotal" class="zx-text-tiny opacity-75 strikethrough"
                    [class.zx-text-white]="isDarkMode">
                    {{ getCalculatedTotal() }} {{ "printing-table.nis" | translate }}
                  </span>
                </div>
              </div>
            </div>
            <div class="col-6" *ngIf="hasShippingOption()">
              <div class="d-flex flex-column gap-1">
                <span class="zx-text-small" [class.zx-text-white]="isDarkMode">{{ "create-price-quote.shipping-cost" | translate }}</span>
                <div class="d-flex align-items-center gap-2 flex-wrap" [class.flex-row-reverse]="!isRTL">
                  <input type="number" min="0" step="0.01" name="shippingInput" class="form-control" style="max-width: 120px;"
                    [(ngModel)]="shippingInputValue" (ngModelChange)="onShippingInputChange()" (blur)="onShippingBlur()"
                    [placeholder]="'0'" [class.zx-text-white]="isDarkMode" />
                  <span class="zx-text-small" [class.zx-text-white]="isDarkMode">{{ "printing-table.nis" | translate }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="d-flex flex-column gap-1 mt-2">
            <span class="zx-text-small flex-shrink-0" [class.zx-text-white]="isDarkMode">{{ "printing-table.additional-notes" | translate }}</span>
            <textarea class="create-price-quote-note-input flex-grow-1 w-100" rows="2" name="totalNote" [placeholder]="'printing-table.additional-notes-placeholder' | translate"
              [(ngModel)]="totalNote" [class.zx-text-white-bg-transparent]="isDarkMode" [dir]="isRTL ? 'rtl' : 'ltr'"></textarea>
          </div>
        </section>
      </div>
    </div>

    <!-- כפתורים -->
    <div *ngIf="!isPriceQuoteSentSuccess && !isSendingQuote" class="d-flex flex-column flex-lg-row justify-content-center align-items-end w-100 gap-3 pt-2 flex-shrink-0">
      <button type="button" (click)="onSendPriceQuote()" mat-raised-button
        [class.send-btn-disabled]="sendButtonDisabled || isSendingQuote"
        [attr.disabled]="(sendButtonDisabled || isSendingQuote) ? '' : null"
        [attr.aria-disabled]="sendButtonDisabled || isSendingQuote"
        class="rounded-pill zx-btn-single col-12 col-lg-6 fw-bold text-white"
        style="background-color: var(--zx-green);">
        {{ "ph-order-action.send-price-quote-to-user" | translate }}
      </button>
      <button (click)="closeDialog()" color="warn" mat-button
        class="rounded-pill zx-btn-single col-12 col-lg-6 fw-bold">
        {{ "su-management.branches_cancel" | translate }}
      </button>
    </div>
    </ng-container>
  </div>
</div>
